import { createBrowserHistory } from "history";
export let history = createBrowserHistory({ basename: "" });

// Mantiene el <link rel="manifest"> apuntando a la ruta actual (ver public/index.html)
// para que el acceso directo de la PWA se abra donde se creó, aunque el usuario
// haya navegado dentro de la SPA antes de añadirlo a la pantalla de inicio.
history.listen(() => {
  if (typeof window.__updatePwaManifest === "function") {
    window.__updatePwaManifest()
  }
})
